/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payment_Ios_TextInputs */

const en_payment_ios_text = /** @type {(inputs: Payment_Ios_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS`)
};

const id_payment_ios_text = /** @type {(inputs: Payment_Ios_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS`)
};

const ms_payment_ios_text = /** @type {(inputs: Payment_Ios_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS`)
};

const ca_payment_ios_text = /** @type {(inputs: Payment_Ios_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS`)
};

const cs_payment_ios_text = /** @type {(inputs: Payment_Ios_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS`)
};

const da_payment_ios_text = /** @type {(inputs: Payment_Ios_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS`)
};

const de_payment_ios_text = /** @type {(inputs: Payment_Ios_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS`)
};

const et_payment_ios_text = /** @type {(inputs: Payment_Ios_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS`)
};

const es_payment_ios_text = /** @type {(inputs: Payment_Ios_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS`)
};

const fr_payment_ios_text = /** @type {(inputs: Payment_Ios_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS`)
};

const hr_payment_ios_text = /** @type {(inputs: Payment_Ios_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS`)
};

const it_payment_ios_text = /** @type {(inputs: Payment_Ios_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS`)
};

const lv_payment_ios_text = /** @type {(inputs: Payment_Ios_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS`)
};

const lt_payment_ios_text = /** @type {(inputs: Payment_Ios_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`„iOS“`)
};

const hu_payment_ios_text = /** @type {(inputs: Payment_Ios_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS`)
};

const nl_payment_ios_text = /** @type {(inputs: Payment_Ios_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS`)
};

const nb_payment_ios_text = /** @type {(inputs: Payment_Ios_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS`)
};

const pl_payment_ios_text = /** @type {(inputs: Payment_Ios_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS`)
};

const pt_payment_ios_text = /** @type {(inputs: Payment_Ios_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS`)
};

const ro_payment_ios_text = /** @type {(inputs: Payment_Ios_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS`)
};

const sk_payment_ios_text = /** @type {(inputs: Payment_Ios_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS`)
};

const sl_payment_ios_text = /** @type {(inputs: Payment_Ios_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS`)
};

const fi_payment_ios_text = /** @type {(inputs: Payment_Ios_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS`)
};

const sv_payment_ios_text = /** @type {(inputs: Payment_Ios_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS`)
};

const vi_payment_ios_text = /** @type {(inputs: Payment_Ios_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS`)
};

const tr_payment_ios_text = /** @type {(inputs: Payment_Ios_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS`)
};

const el_payment_ios_text = /** @type {(inputs: Payment_Ios_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS`)
};

const bg_payment_ios_text = /** @type {(inputs: Payment_Ios_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS`)
};

const ru_payment_ios_text = /** @type {(inputs: Payment_Ios_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS`)
};

const sr_payment_ios_text = /** @type {(inputs: Payment_Ios_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS`)
};

const uk_payment_ios_text = /** @type {(inputs: Payment_Ios_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS`)
};

const ka_payment_ios_text = /** @type {(inputs: Payment_Ios_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS`)
};

const hi_payment_ios_text = /** @type {(inputs: Payment_Ios_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS`)
};

const th_payment_ios_text = /** @type {(inputs: Payment_Ios_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS`)
};

const ko_payment_ios_text = /** @type {(inputs: Payment_Ios_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS`)
};

const zh_payment_ios_text = /** @type {(inputs: Payment_Ios_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS`)
};

const zh_tw_payment_ios_text = /** @type {(inputs: Payment_Ios_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS 版`)
};

const ja_payment_ios_text = /** @type {(inputs: Payment_Ios_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iOS`)
};

/**
* | output |
* | --- |
* | "iOS" |
*
* @param {Payment_Ios_TextInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const payment_ios_text = /** @type {((inputs?: Payment_Ios_TextInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_Ios_TextInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_payment_ios_text(inputs)
	if (locale === "ms") return ms_payment_ios_text(inputs)
	if (locale === "ca") return ca_payment_ios_text(inputs)
	if (locale === "cs") return cs_payment_ios_text(inputs)
	if (locale === "da") return da_payment_ios_text(inputs)
	if (locale === "de") return de_payment_ios_text(inputs)
	if (locale === "et") return et_payment_ios_text(inputs)
	if (locale === "es") return es_payment_ios_text(inputs)
	if (locale === "fr") return fr_payment_ios_text(inputs)
	if (locale === "hr") return hr_payment_ios_text(inputs)
	if (locale === "it") return it_payment_ios_text(inputs)
	if (locale === "lv") return lv_payment_ios_text(inputs)
	if (locale === "lt") return lt_payment_ios_text(inputs)
	if (locale === "hu") return hu_payment_ios_text(inputs)
	if (locale === "nl") return nl_payment_ios_text(inputs)
	if (locale === "nb") return nb_payment_ios_text(inputs)
	if (locale === "pl") return pl_payment_ios_text(inputs)
	if (locale === "pt") return pt_payment_ios_text(inputs)
	if (locale === "ro") return ro_payment_ios_text(inputs)
	if (locale === "sk") return sk_payment_ios_text(inputs)
	if (locale === "sl") return sl_payment_ios_text(inputs)
	if (locale === "fi") return fi_payment_ios_text(inputs)
	if (locale === "sv") return sv_payment_ios_text(inputs)
	if (locale === "vi") return vi_payment_ios_text(inputs)
	if (locale === "tr") return tr_payment_ios_text(inputs)
	if (locale === "el") return el_payment_ios_text(inputs)
	if (locale === "bg") return bg_payment_ios_text(inputs)
	if (locale === "ru") return ru_payment_ios_text(inputs)
	if (locale === "sr") return sr_payment_ios_text(inputs)
	if (locale === "uk") return uk_payment_ios_text(inputs)
	if (locale === "ka") return ka_payment_ios_text(inputs)
	if (locale === "hi") return hi_payment_ios_text(inputs)
	if (locale === "th") return th_payment_ios_text(inputs)
	if (locale === "ko") return ko_payment_ios_text(inputs)
	if (locale === "zh") return zh_payment_ios_text(inputs)
	if (locale === "zh-tw") return zh_tw_payment_ios_text(inputs)
	if (locale === "ja") return ja_payment_ios_text(inputs)
	return en_payment_ios_text(inputs)
});